import { objNamesToCamelCase } from "common/utils/helpers/cases";
import type { DesignLabConfig } from "@design-lab/shared/lib/config";
import { AppProviders } from "./providers";
import { AppRoutes } from "./routes";
import { ErrorBoundary } from "./ErrorBoundary";

export function App({ config }: { config: DesignLabConfig }) {
  const camelCaseConfig = objNamesToCamelCase(config);

  return (
    <ErrorBoundary>
      <AppProviders config={camelCaseConfig}>
        <AppRoutes />
      </AppProviders>
    </ErrorBoundary>
  );
}
